import { createUnifiedTheme, genPageTheme, palettes } from '@backstage/theme';
import { tokens } from '@neo4j-ndl/base';

import { FALLBACK_FONT_STACK } from './const';

export const auraDarkTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    primary: {
      main: tokens.theme.dark.color.primary.text,
      contrastText: tokens.theme.dark.color.neutral.text.inverse,
    },
    secondary: {
      main: tokens.theme.dark.color.primary.border.weak,
      contrastText: tokens.theme.dark.color.neutral.text.inverse,
    },
    error: {
      main: tokens.theme.dark.color.danger.text,
    },
    warning: {
      main: tokens.theme.dark.color.warning.text,
    },
    info: {
      main: tokens.theme.dark.color.primary.text,
    },
    success: {
      main: tokens.theme.dark.color.success.text,
    },
    background: {
      default: tokens.theme.dark.color.neutral.bg.weak,
      paper: tokens.theme.dark.color.neutral.bg.weak,
    },
    banner: {
      info: tokens.theme.dark.color.primary.text,
      error: tokens.theme.dark.color.danger.text,
      warning: tokens.theme.dark.color.warning.bg.weak,
      text: tokens.theme.dark.color.primary.text,
      link: tokens.theme.dark.color.primary.text,
    },
    errorBackground: tokens.theme.dark.color.danger.bg.weak,
    warningBackground: tokens.theme.dark.color.warning.bg.weak,
    infoBackground: tokens.theme.dark.color.primary.bg.weak,
    navigation: {
      background: tokens.theme.dark.color.neutral.bg.weak,
      indicator: tokens.theme.dark.color.primary.text,
      color: tokens.theme.dark.color.neutral.text.default,
      selectedColor: tokens.theme.dark.color.primary.text,
      navItem: {
        hoverBackground: tokens.theme.dark.color.neutral.hover,
      },
      submenu: {
        background: tokens.theme.dark.color.neutral.bg.strong,
      },
    },
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 8,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '0.75rem',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardError: {
          backgroundColor: tokens.theme.dark.color.danger.bg.weak,
          color: tokens.theme.dark.color.danger.text,
          border: `1px solid ${tokens.theme.dark.color.danger.border.strong}`,
        },
        standardWarning: {
          backgroundColor: tokens.theme.dark.color.warning.bg.weak,
          color: tokens.theme.dark.color.warning.text,
          border: `1px solid ${tokens.theme.dark.color.warning.border.strong}`,
        },
        standardSuccess: {
          backgroundColor: tokens.theme.dark.color.success.bg.weak,
          color: tokens.theme.dark.color.success.text,
          border: `1px solid ${tokens.theme.dark.color.success.border.strong}`,
        },
        standardInfo: {
          backgroundColor: tokens.theme.dark.color.primary.bg.weak,
          color: tokens.theme.dark.color.primary.text,
          border: `1px solid ${tokens.theme.dark.color.primary.border.strong}`,
        },
        icon: {
          color: 'inherit',
        },
      },
    },
  },
  defaultPageTheme: 'home',
  fontFamily: `Nunito Sans, ${FALLBACK_FONT_STACK}`,
  /* below drives the header colors */
  pageTheme: {
    home: genPageTheme({
      colors: [tokens.theme.dark.color.primary.bg.strong],
      shape: 'none',
      options: {
        fontColor: tokens.theme.dark.color.neutral.text.inverse,
      },
    }),
    documentation: genPageTheme({
      colors: [tokens.theme.dark.color.primary.bg.strong],
      shape: 'none',
      options: {
        fontColor: tokens.theme.dark.color.neutral.text.inverse,
      },
    }),
    tool: genPageTheme({
      colors: [tokens.theme.dark.color.primary.bg.strong],
      shape: 'none',
      options: {
        fontColor: tokens.theme.dark.color.neutral.text.inverse,
      },
    }),
    service: genPageTheme({
      colors: [tokens.theme.dark.color.primary.bg.strong],
      shape: 'none',
      options: {
        fontColor: tokens.theme.dark.color.neutral.text.inverse,
      },
    }),
    website: genPageTheme({
      colors: [tokens.theme.dark.color.primary.bg.strong],
      shape: 'none',
      options: {
        fontColor: tokens.theme.dark.color.neutral.text.inverse,
      },
    }),
    library: genPageTheme({
      colors: [tokens.theme.dark.color.primary.bg.strong],
      shape: 'none',
      options: {
        fontColor: tokens.theme.dark.color.neutral.text.inverse,
      },
    }),
    other: genPageTheme({
      colors: [tokens.theme.dark.color.primary.bg.strong],
      shape: 'none',
    }),
    app: genPageTheme({
      colors: [tokens.theme.dark.color.primary.bg.strong],
      shape: 'none',
    }),
    apis: genPageTheme({
      colors: [tokens.theme.dark.color.primary.bg.strong],
      shape: 'none',
    }),
  },
});
